import React from 'react';
import { Box, Typography } from '@mui/material';

import { ICandidateDetails, IPerson } from '@types';
import { PersonSignature } from 'components/common/PersonSignature/PersonSignature';
import { ScoreCell } from 'components/common/ScoreCell/ScoreCell';
import { Row } from './DetailFacts';

export const TestTaskBlock: React.FC<{ data: ICandidateDetails }> = ({
  data,
}) => {
  const testTask = data.testTasks?.[0];
  if (!testTask) return null;

  if (testTask.isPending)
    return (
      <Box>
        <Row label="Result">
          <Typography variant="body1" color="text.lightGrey">
            Pending
          </Typography>
        </Row>
      </Box>
    );

  return (
    <Box>
      <Row label="Score">
        <ScoreCell
          testTask={{
            score: testTask.score,
            status: testTask.status,
            isPending: testTask.isPending,
          }}
          label="test task"
          plain
        />
      </Row>
      {Boolean(testTask.feedback) && (
        <Row label="Feedback">
          <Typography variant="body1" whiteSpace="pre-line">
            {testTask.feedback}
          </Typography>
          {Boolean(testTask.reviewer) && (
            <Box mt={1}>
              <PersonSignature person={testTask.reviewer as IPerson} />
            </Box>
          )}
        </Row>
      )}
    </Box>
  );
};
